import { render, staticRenderFns } from "./SubscriptionChoices.vue?vue&type=template&id=168f1665"
import script from "./SubscriptionChoices.vue?vue&type=script&lang=js"
export * from "./SubscriptionChoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports